module.exports = __webpack_public_path__ + "img/ertiga-xl7-negro-cosmos.6d6efa08.png";